import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { label } from '@entities/ksp/format';
import { Card, Muted } from '../styles';
import { tabHref, tabTitle } from '../types';
import { attention, type PulseInput, type Severity } from './pulse';

const List = styled.ul`
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
`;
const Item = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  &:last-child {
    border-bottom: 0;
  }
`;
const Row = styled(Link)`
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: start;
  padding: 10px 2px;
  color: inherit;
  text-decoration: none;
  &:hover strong {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
const Icon = styled.span<{ $severity: Severity }>`
  width: 20px;
  height: 20px;
  margin-top: 1px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 800;
  color: ${({ theme, $severity }) =>
    $severity === 'bad'
      ? theme.colors.status.danger
      : $severity === 'warn'
        ? theme.colors.status.warning
        : theme.colors.status.info};
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid currentColor;
`;
const Text = styled.span`
  min-width: 0;
  strong {
    display: block;
    font-weight: 600;
    font-size: 13.5px;
  }
  span {
    display: block;
    font-size: 12.5px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
const Where = styled.span`
  font-size: 12px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.text.muted};
`;

const SEVERITY_TEXT: Record<Severity, string> = {
  bad: 'Срочно',
  warn: 'Нужно сделать',
  info: 'Для сведения',
};

/** Что мешает расчёту или ждёт решения — каждая строка ведёт туда, где это исправляют. */
export function AttentionCard({
  input,
  params,
  now,
}: {
  input: PulseInput;
  params: URLSearchParams;
  now: Date;
}) {
  const items = attention(input, label, now);
  return (
    <Card>
      <h3>Требует внимания</h3>
      {items.length === 0 ? (
        <Muted>Всё в порядке: расчёт опубликован, вехи заведены, факт принят.</Muted>
      ) : (
        <List>
          {items.map((item) => (
            <Item key={item.key}>
              <Row to={tabHref(params, item.tab)} title={SEVERITY_TEXT[item.severity]}>
                <Icon $severity={item.severity} aria-label={SEVERITY_TEXT[item.severity]}>
                  {item.severity === 'info' ? 'i' : '!'}
                </Icon>
                <Text>
                  <strong>{item.title}</strong>
                  {item.detail && <span>{item.detail}</span>}
                </Text>
                <Where>{tabTitle(item.tab)} →</Where>
              </Row>
            </Item>
          ))}
        </List>
      )}
    </Card>
  );
}
